import { connect } from 'react-redux';

import FrequentQuestions from '../components/pages/frequent-questions';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({

});

const FrequentQuestionsConnector = connect(mapStateToProps, mapDispatchToProps)(FrequentQuestions);

export default FrequentQuestionsConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/frequent-questions-connector.js
 **/